import React, {Component, Fragment} from "react";

import "./index.scss";
import desktop_exit from "../../../../assets/icons/login-x-icon.svg";
import {sendAppLinkSms, setVehicleAdsOnSuccess, smartWalletApplication} from "redux/actions";
import {connect} from "react-redux";
import CarLeadForm from "containers/car_lead/sections/car_lead_form";
import paper_plane from 'assets/icons/paper-plane.svg';


class CarLeadFormPopup extends Component {

    constructor(props) {
        super(props);
        this.dispatch = null;
        this.state = {
            animation_class: '',
            popup_id: this.props.popup_id,
            expertClass: "",
        }
        this.animateOut = this.animateOut.bind(this);
        this.animateIn  = this.animateIn.bind(this);
    }

    /* add class for animation after it is inserted into the DOM */
    componentDidMount() {
        this.animateIn();
        this.setPageHeight();
        if(this.props.isExpert && (this.props.deviceState === "desktop" || this.props.deviceState === "desktop-large")){
            this.setState({expertClass:"expert"});
        }
    }

    componentWillUnmount() {
    }

    animateIn() {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setState({animation_class: 'active'});
            })
        })
    }
    /* first remove the active class for exit animation then call the callback */
    animateOut(callback) {
        this.setState({animation_class: ''});
        setTimeout(() => {
            if(callback) {
                callback(this.state.selected_id);
            }
            this.props.handleClose();
        }, 200);
    }

    handleSubmit =() => {
        this.props.handleClose();
        this.props.action();
    }

    setPageHeight(){
        if(this.props.deviceState === "mobile" || this.props.deviceState === "tablet"){
            let fullHeight = this.props.screenHeight;
            document.getElementById("car-lead-form-popup-id").style.height = fullHeight + "px";

        }
    }


    render(){
        let text = this.props.translations;

        const id  = this.props.data?.id ? this.props.data.id : this.props.data;
        return (
            <div className = { "backdrop " + this.state.animation_class } onClick = { () => this.animateOut() }>
                <div className = {"popup_wrapper car-lead-form-popup " + this.state.animation_class + " " +this.state.expertClass} id="car-lead-form-popup-id" onClick = { (e) => e.stopPropagation() }>
                    <div className = "popup_content ">
                        <button className = "x_close_icon"
                                onClick = { () => this.animateOut() }
                        >
                            <img src={desktop_exit} alt=''/>
                        </button>

                        {!this.props.vehicleAdsOnSuccess.includes(parseInt(id)) &&
                            <Fragment>
                                <div className="popup-title-wrapper">
                                    {!this.props.isExpert &&
                                         <span className="popup-title">{this.props.title}</span>
                                    }
                                    <span className="popup-title-bold">{this.props.titleBold}</span>
                                </div>

                                <div className = "popup_content2">
                                    <CarLeadForm data={this.props.data} isExpert={this.props.isExpert} title={this.props.title} titleBold={this.props.titleBold}/>
                                </div>
                            </Fragment>
                        }

                        {this.props.vehicleAdsOnSuccess.includes(parseInt(id)) &&
                            <div className="thanks-note-wrapper">
                                <img className="thanks-note-image" src={paper_plane} alt=""/>
                                <span className="thanks-note-title">{text["car_lead_popup_success_title"]}</span>
                                <span className="thanks-note-text">{text["car_lead_popup_success_text"]}</span>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

//connect to redux store
const mapStateToProps = store => {
    return {
        deviceState: store.state.deviceState,
        text: store.config.PopTrans,
        PopTrans:store.config.PopTrans,
        translations:store.config.Translations,
        vehicleAdsOnSuccess:store.data.VehicleAdsOnSuccess,
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        dispatch: dispatch,
        setVehicleAdsOnSuccess:(payload) => dispatch(setVehicleAdsOnSuccess(payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(CarLeadFormPopup);
